export const HOMEPAGE_EVENTS = {
  AGGREGATION_CHANGED: 'homepage_aggregation_changed',
  TEAM_CHANGED: 'homepage_team_changed',
  CHANNEL_CHANGED: 'homepage_channel_changed',
  CLICK_DIRECTOR_MESSAGE_EDIT: 'click_homepage_director_message_edit',
  DIRECTOR_MESSAGE_UPDATED: 'homepage_director_message_updated',
  CLICK_TARGET_PRODUCTIVITY_EDIT: 'click_homepage_target_productivity_edit',
  TARGET_PRODUCTIVITY_UPDATED: 'homepage_target_productivity_updated',
  CARD_REDIRECT_CLICK: 'click_homepage_card_redirect',
  CLICK_ALERT_ACTION: 'click_homepage_alert_action',
  CLICK_ALERT_DISMISS: 'click_homepage_alert_dismiss',
  CLICK_LAST_WEEK: 'click_homepage_last_week',
  CLICK_NEXT_WEEK: 'click_homepage_next_week'
} as const

export type HomepageEvent = (typeof HOMEPAGE_EVENTS)[keyof typeof HOMEPAGE_EVENTS]

export const HOMEPAGE_CARD_REDIRECTS = {
  WEEKLY: 'weekly',
  DAILY: 'daily',
  LAST_FOUR_WEEKS_STORE: 'last_four_weeks_store',
  LAST_FOUR_WEEKS_TEAM: 'last_four_weeks_team'
} as const
